<template>
  <div>
    <!-- Stats component - currently empty template -->
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';

const MI = 1609.344;

const props = defineProps({
  activities: {
    type: Array,
    required: true,
  },
});

const progress = ref(0);
const onTarget = ref(false);
const totalMi = ref(0);

onMounted(() => {
  const today = new Date();
  const endOfYear = new Date(today.getFullYear(), 11, 31);
  const oneDay = 1000 * 60 * 60 * 24;
  const daysLeft = Math.ceil((endOfYear.getTime() - today.getTime()) / oneDay);
  const percDaysLeft = (daysLeft / 365) * 100;

  let totalM = 0;
  for (const activity of props.activities) {
    totalM += parseFloat(activity.distance);
  }
  totalMi.value = totalM / MI;
  progress.value = (totalMi.value / 3000) * 100;

  if (percDaysLeft > (100 - progress.value)) {
    onTarget.value = true;
  }
});
</script>

<style lang="scss" scoped>
</style>
